module.exports = {
      id: "crime-usage",
      viewBox: "0 0 69.07 72.614",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#crime",
      toString: function () {
        return this.url;
      }
    }